import React, { useContext } from "react";
import { I18nContext } from "../context/I18nProvider";

import Header from "./Header/Header";
import Whatsapp from "../components/whatsapp/Whatsapp";
import Footer from "./Footer/Footer";

const Layout = ({ children }) => {
  const { language } = useContext(I18nContext);

  return (
    <>
      <Header language={language} />
      {children}
      <Whatsapp />
      <Footer language={language} />
    </>
  );
};

export default Layout;
